<template>
  <div v-if="planDetails">
    <b-card>
      <h1>ویرایش پلن {{ planDetails.title }}</h1>
      <b-form class="mt-2">
        <b-row>
          <b-col md="6">
            <b-form-group label="عنوان پلن" label-for="title" class="mb-2">
              <b-form-input id="plan-price" v-model="planDetails.title" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="قیمت (تومان)"
              label-for="plan-price"
              class="mb-2"
            >
              <b-form-input id="plan-price" v-model="planDetails.price" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              :label="countTitleHandler"
              label-for="plan-count"
              class="mb-2"
            >
              <b-form-input id="plan-count" v-model="planDetails.count" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="مدت فعال بودن پلن (روز)"
              label-for="plan-expire"
              class="mb-2"
            >
              <b-form-input id="plan-expire" v-model="planDetails.expireDays" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-50">
            <b-button
              variant="primary"
              class="mr-1"
              @click="sendPlanUpdateRequest"
            >
              ویرایش پلن
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import PlanGetRequest from "@/libs/Api/Plans/PlanGetRequest";
import PlanUpdateRequest from "@/libs/Api/Plans/PlanUpdateRequest";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BTabs,
  BTab,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BPagination,
  BFormGroup,
  BForm,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BTabs,
    BTab,
    BFormGroup,
    BFormTextarea,
    BBadge,
    BForm,
    BDropdown,
    BDropdownItem,
    BPagination,
    ToastificationContent,
    BModal,
    vSelect,
  },
  async created() {
    await this.getPlan();
  },
  data() {
    return {
      planDetails: null,
      userType: [
        {
          name: "ثبت کننده",
          value: 1,
        },
        {
          name: "بازدید کننده",
          value: 2,
        },
      ],
      planType: [
        {
          name: "نردبان",
          value: 1,
        },
        {
          name: "پکیج ثبت آگهی",
          value: 2,
        },
        {
          name: "پکیج بازدید آگهی",
          value: 3,
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    async getPlan() {
      let _this = this;
      let planGetRequest = new PlanGetRequest(_this);
      planGetRequest.setId(_this.$route.params.id);
      await planGetRequest.fetch(
        function (content) {
          _this.planDetails = content;
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async sendPlanUpdateRequest() {
      let _this = this;
      let planUpdateRequest = new PlanUpdateRequest(_this);
      planUpdateRequest.setParams(_this.planDetails);
      await planUpdateRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `پلن با موفقیت ویرایش شد.`,
            },
          });
          _this.$router.push({ name: "apps-plans-list" });
        },
        function (error) {
          console.log(error);
        }
      );
    },
  },
  computed: {
    countTitleHandler() {
      if (this.planDetails.userType) {
        if (this.planDetails.userType == 1) {
          return "تعداد آگهی قابل ثبت";
        } else if (this.planDetails.userType == 2) {
          return "تعداد آگهی قابل مشاهده";
        }
      } else {
        return "تعداد";
      }
    },
  },
};
</script>
